
import React from 'react';
import { Button } from '@/components/ui/button';
import { Eye, EyeOff } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { Switch } from '@/components/ui/switch';
import { useDashboard } from '@/contexts/dashboard';

const KpiVisibilityManager: React.FC = () => {
  const { kpiCards, updateKpiCard } = useDashboard();
  
  const toggleCardVisibility = (id: string, visible: boolean) => {
    updateKpiCard(id, { visible });
  };

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" className="mr-2">
          <Eye className="mr-2 h-4 w-4" />
          Card Visibility
        </Button>
      </SheetTrigger>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>Manage Dashboard Cards</SheetTitle>
          <SheetDescription>
            Toggle the visibility of dashboard cards
          </SheetDescription>
        </SheetHeader>
        
        <div className="py-6">
          <div className="space-y-4">
            {kpiCards.map(card => (
              <div key={card.id} className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  {card.visible ? (
                    <Eye className="h-4 w-4 text-gray-500" />
                  ) : (
                    <EyeOff className="h-4 w-4 text-gray-500" />
                  )}
                  <span>{card.title}</span>
                </div>
                
                <Switch
                  checked={card.visible}
                  onCheckedChange={(checked) => toggleCardVisibility(card.id, checked)}
                />
              </div>
            ))}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default KpiVisibilityManager;
